import "./styles.sass";

import React, { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CalcItem from "./CalcItem";
import Breadcrumbs from "../../../components/breadcrumbs/CHBreadcrubs";
import { Context } from "../../..";
import { ICalcs } from "../../../models/IUserCalc/ICalcs";
import { useSelectedUser } from "../../../customHooks/useSelectetUser";
import BackButton from "../../../components/UI/button/BackButton";
import { formatCalcName, sortByDate } from "../../../utils";
import Spinner from "../../../components/UI/spinner/Spinner";

const CalcPage: FC = () => {
  const { users, roles, store } = useContext(Context);
  const [calcItem, setCalcItem] = useState<any>([]);
  const { calc, id } = useParams();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [adminPermissionData, setAdminPermissionData] = useState<any>();

  useSelectedUser();

  useEffect(() => {
    if (Object.keys(users.selectedUser).length > 0) {
      getCalcs();
    } else {
      loadNewUser();
    }
  }, [users.selectedUser]);

  const getCalcs = () => {
    const calcProp = calc as keyof ICalcs;
    const calcs: any = users.selectedUser?.calc;
    setCalcItem(sortByDate(calcs[calcProp], "created_at"));
    setLoading(false);
  };

  async function loadNewUser() {
    const userId = JSON.parse(localStorage.getItem("user") || "");
    const response = await users.loadOne(users?.selectedUser?._id || userId);
    if (response) {
      users.setSelectedUser(response);
      getCalcs();
      setLoading(false);
    }
  }

  const loadNewData = async () => {
    const userData = store?.user?.role
      ?.find((par: any) => par?.path === "control")
      ?.children?.find((child: any) => child.path === "users");
    setAdminPermissionData(userData);
  };

  useEffect(() => {
    loadNewData();
  }, []);

  return (
    <div className="calculators">
      <div className="calculators-header">
        <div className="title-container">
          <BackButton />
          <div className="title"> {formatCalcName(calc || "")}</div>
        </div>
        {/* <Breadcrumbs paramsTitle={{ id: id, calc: calc }} /> */}
      </div>
      <div className="body">
        {loading ? (
          <Spinner style={{ justifyContent: "flex-end" }} />
        ) : (
          <>
            {calcItem &&
              calcItem.map((item: any, index: number) => (
                <CalcItem
                  setCalcItem={setCalcItem}
                  data={item}
                  key={item.name}
                  pathObject={`${item.name.split(" ")?.[0]}/${index}`}
                  user={users.selectedUser}
                  actionData={adminPermissionData}
                />
              ))}
          </>
        )}
      </div>
    </div>
  );
};

export default CalcPage;
